import { InfoNote } from '../../components/InfoNote';
import { SectionHeader } from '../../components/SectionHeader';
import { TimeslotRow } from '../../components/TimeslotRow';
import { TimeChangeIcon } from '../../icons/TimeChangeIcon';
import { OptionsList, Panel } from './AllOptionsTimeslotPanel.styles';
import type { AllOptionsTimeslotPanelProps } from './AllOptionsTimeslotPanel.types';

const defaultNoteIcon = <TimeChangeIcon size={18} />;

export function AllOptionsTimeslotPanel({
  title = 'Options.',
  subtitle = 'Choose your times.',
  options,
  onTimeslotChange,
  noteText,
  noteIcon = defaultNoteIcon,
  timeslotPlaceholder,
  timeslotAriaLabelFormatter,
  timeslotErrors,
  timeslotNotices,
}: AllOptionsTimeslotPanelProps) {
  return (
    <Panel>
      <SectionHeader title={title} subtitle={subtitle} />
      <OptionsList>
        {options.map((option) => (
          <TimeslotRow
            key={option.id}
            label={option.label}
            timeslots={option.timeslots}
            selectedTimeslot={option.selectedTimeslot}
            onChange={(value) => onTimeslotChange(option.id, value)}
            timeslotPlaceholder={timeslotPlaceholder}
            ariaLabelFormatter={timeslotAriaLabelFormatter}
            disabled={option.disabled}
            error={timeslotErrors?.[option.id]}
            notice={timeslotNotices?.[option.id]}
          />
        ))}
      </OptionsList>
      {noteText && <InfoNote text={noteText} icon={noteIcon} />}
    </Panel>
  );
}
